import { isArrayWithLength } from '../../helpers';
import { LOADING_GET_ADMIN_EMAILS, LOADING_GET_ADMIN_EMAILS_SUCCESS, LOADING_GET_ADMIN_EMAILS_ERROR } from './types';

const initialState = {
  userData: [],
  isLoading: false,
  isError: false,
};

export const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case LOADING_GET_ADMIN_EMAILS:
      return {
        ...state,
        isLoading: true,
      };
    case LOADING_GET_ADMIN_EMAILS_SUCCESS:
      return {
        ...state,
        userData: getUserDropdownShapedArray(action.payload),
        isLoading: false,
        isError: false,
      };
    case LOADING_GET_ADMIN_EMAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
};

const getUserDropdownShapedArray = (payloadArr) => {
  return isArrayWithLength(payloadArr)
    ? payloadArr.map((user) => ({
      value: user.oid,
      label: user.displayName,
    }))
    : [];
};
